import * as React from "react"

const MOBILE_BREAKPOINT = 768

// 767.98px et non 768 : un viewport à exactement 768px doit être desktop,
// aligné sur le `md:` de Tailwind (min-width: 768px). matchMedia remplace le
// listener resize : une seule notification au franchissement du seuil au lieu
// d'un re-render par événement de redimensionnement.
const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 0.02}px)`

export function useIsMobile() {
  // Initialisation synchrone : pas de flash desktop→mobile au premier rendu.
  const [isMobile, setIsMobile] = React.useState<boolean>(
    () => window.matchMedia(QUERY).matches
  )

  React.useEffect(() => {
    const mql = window.matchMedia(QUERY)
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches)
    // Resynchronisation si le viewport a changé entre le rendu et l'effet.
    setIsMobile(mql.matches)
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
